import get from 'lodash/get';

import * as payfacCardService from '../../services/payfacCardService';

// --- Existing action types ---------------------------------------------------
export const SET_PAYFAC_INVOICES = 'SET_PAYFAC_INVOICES';
export const GET_PAYFAC_INVOICES = 'GET_PAYFAC_INVOICES';
export const UPDATE_INVOICE_AMOUNT = 'UPDATE_INVOICE_AMOUNT';

// --- Tokenization URL --------------------------------------------------------
export const PAYFAC_GET_TOKENIZATION_URL_REQUEST = 'PAYFAC_GET_TOKENIZATION_URL_REQUEST';
export const PAYFAC_GET_TOKENIZATION_URL_SUCCESS = 'PAYFAC_GET_TOKENIZATION_URL_SUCCESS';
export const PAYFAC_GET_TOKENIZATION_URL_ERROR = 'PAYFAC_GET_TOKENIZATION_URL_ERROR';

// --- Send tokenization email -------------------------------------------------
export const PAYFAC_SEND_TOKENIZATION_EMAIL_REQUEST = 'PAYFAC_SEND_TOKENIZATION_EMAIL_REQUEST';
export const PAYFAC_SEND_TOKENIZATION_EMAIL_SUCCESS = 'PAYFAC_SEND_TOKENIZATION_EMAIL_SUCCESS';
export const PAYFAC_SEND_TOKENIZATION_EMAIL_ERROR = 'PAYFAC_SEND_TOKENIZATION_EMAIL_ERROR';

// --- Customer cards ----------------------------------------------------------
export const PAYFAC_GET_CUSTOMER_CARDS_REQUEST = 'PAYFAC_GET_CUSTOMER_CARDS_REQUEST';
export const PAYFAC_GET_CUSTOMER_CARDS_SUCCESS = 'PAYFAC_GET_CUSTOMER_CARDS_SUCCESS';
export const PAYFAC_GET_CUSTOMER_CARDS_ERROR = 'PAYFAC_GET_CUSTOMER_CARDS_ERROR';

// --- Delete card -------------------------------------------------------------
export const PAYFAC_DELETE_CARD_REQUEST = 'PAYFAC_DELETE_CARD_REQUEST';
export const PAYFAC_DELETE_CARD_SUCCESS = 'PAYFAC_DELETE_CARD_SUCCESS';
export const PAYFAC_DELETE_CARD_ERROR = 'PAYFAC_DELETE_CARD_ERROR';

// --- Toggle autopay ----------------------------------------------------------
export const PAYFAC_TOGGLE_AUTOPAY_REQUEST = 'PAYFAC_TOGGLE_AUTOPAY_REQUEST';
export const PAYFAC_TOGGLE_AUTOPAY_SUCCESS = 'PAYFAC_TOGGLE_AUTOPAY_SUCCESS';
export const PAYFAC_TOGGLE_AUTOPAY_ERROR = 'PAYFAC_TOGGLE_AUTOPAY_ERROR';

// --- Existing action creators ------------------------------------------------
export const setPayfacInvoices = invoices => ({
  type: SET_PAYFAC_INVOICES,
  payload: invoices
});

export const updateInvoiceAmount = (invoiceUuid, amountToPay) => ({
  type: UPDATE_INVOICE_AMOUNT,
  payload: { invoiceUuid, amountToPay }
});

// --- Thunks ------------------------------------------------------------------

export const fetchTokenizationUrl = customerUuid => async dispatch => {
  dispatch({ type: PAYFAC_GET_TOKENIZATION_URL_REQUEST });
  try {
    const url = await payfacCardService.getTokenizationUrl(customerUuid);
    dispatch({ type: PAYFAC_GET_TOKENIZATION_URL_SUCCESS, payload: url });
  } catch (error) {
    dispatch({ type: PAYFAC_GET_TOKENIZATION_URL_ERROR });
    throw error;
  }
};

export const sendTokenizationEmail = (customerUuid, emails) => async dispatch => {
  dispatch({ type: PAYFAC_SEND_TOKENIZATION_EMAIL_REQUEST });
  try {
    await payfacCardService.sendTokenizationEmail(customerUuid, emails);
    dispatch({ type: PAYFAC_SEND_TOKENIZATION_EMAIL_SUCCESS });
  } catch (error) {
    dispatch({ type: PAYFAC_SEND_TOKENIZATION_EMAIL_ERROR });
    throw error;
  }
};

export const fetchCustomerCards = (customerUuid, page = 1) => async dispatch => {
  dispatch({ type: PAYFAC_GET_CUSTOMER_CARDS_REQUEST });
  try {
    const result = await payfacCardService.getCustomerCards(customerUuid, page);
    dispatch({ type: PAYFAC_GET_CUSTOMER_CARDS_SUCCESS, payload: result });
  } catch (error) {
    dispatch({ type: PAYFAC_GET_CUSTOMER_CARDS_ERROR });
    throw error;
  }
};

export const deleteCustomerCard = (customerUuid, cardUuid) => async dispatch => {
  dispatch({ type: PAYFAC_DELETE_CARD_REQUEST, payload: { cardUuid } });
  try {
    await payfacCardService.deleteCard(customerUuid, cardUuid);
    dispatch({ type: PAYFAC_DELETE_CARD_SUCCESS, payload: { cardUuid } });
  } catch (error) {
    dispatch({ type: PAYFAC_DELETE_CARD_ERROR, payload: { cardUuid } });
    throw error;
  }
};

export const toggleCardAutopay = (customerUuid, cardUuid, enabled) => async dispatch => {
  dispatch({ type: PAYFAC_TOGGLE_AUTOPAY_REQUEST, payload: { cardUuid } });
  const result = await payfacCardService.toggleCardAutopay(customerUuid, cardUuid, enabled);
  if (result.success) {
    dispatch({ type: PAYFAC_TOGGLE_AUTOPAY_SUCCESS, payload: { cardUuid, enabled } });
  } else {
    dispatch({ type: PAYFAC_TOGGLE_AUTOPAY_ERROR, payload: { cardUuid } });
  }
  return result;
};

// --- Portal client cards (no operator auth) ----------------------------------
export const PORTAL_GET_CARDS_REQUEST = 'PORTAL_GET_CARDS_REQUEST';
export const PORTAL_GET_CARDS_SUCCESS = 'PORTAL_GET_CARDS_SUCCESS';
export const PORTAL_GET_CARDS_ERROR   = 'PORTAL_GET_CARDS_ERROR';
export const PORTAL_TOGGLE_AUTOPAY_SUCCESS = 'PORTAL_TOGGLE_AUTOPAY_SUCCESS';

// --- Portal card charge ------------------------------------------------------
export const PORTAL_CHARGE_CARD_REQUEST = 'PORTAL_CHARGE_CARD_REQUEST';
export const PORTAL_CHARGE_CARD_SUCCESS = 'PORTAL_CHARGE_CARD_SUCCESS';
export const PORTAL_CHARGE_CARD_ERROR   = 'PORTAL_CHARGE_CARD_ERROR';

// Payfac integration id in the provider's integrations list
const PAYFAC_INTEGRATION_ID = 16;

const hasPayfacIntegration = state => {
  const integrations = get(state, 'portal.provider.team.integration', []);
  const payfacIntegration = integrations.find(
    integration => get(integration, 'integration_id') === PAYFAC_INTEGRATION_ID
  );
  return get(payfacIntegration, 'is_enabled', 0) === 1;
};

export const fetchPortalCards = (customerUuid, page) => async (dispatch, getState) => {
  // Only fetch saved cards when the provider has an active payfac integration
  if (!hasPayfacIntegration(getState())) return;

  dispatch({ type: PORTAL_GET_CARDS_REQUEST });
  try {
    const pageNum = page || 1;
    const result = await payfacCardService.getClientPortalCards(customerUuid, pageNum);
    dispatch({ type: PORTAL_GET_CARDS_SUCCESS, payload: result });
  } catch (error) {
    dispatch({ type: PORTAL_GET_CARDS_ERROR });
  }
};

export const togglePortalCardAutopay = (customerUuid, cardUuid, enabled) => async dispatch => {
  const result = await payfacCardService.toggleClientPortalCardAutopay(customerUuid, cardUuid, enabled);
  if (result.success) {
    dispatch({ type: PORTAL_TOGGLE_AUTOPAY_SUCCESS, payload: { cardUuid, enabled } });
  }
  return result;
};

export const chargePortalCard = (customerUuid, cardUuid, invoices, pendingInvoices) => async dispatch => {
  dispatch({ type: PORTAL_CHARGE_CARD_REQUEST });
  const result = await payfacCardService.chargePortalCard(customerUuid, cardUuid, invoices, pendingInvoices);
  if (result.success) {
    dispatch({ type: PORTAL_CHARGE_CARD_SUCCESS });
  } else {
    dispatch({ type: PORTAL_CHARGE_CARD_ERROR });
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/redux/actions/payfacActions.js